<template>
  <div >
  <v-container style="background-color: white; border-radius: 5px; max-width: 1000px" >
    <v-layout
      wrap
    >
      <v-flex xs12 md3 class="taps-title">
        T.A.P.S
      </v-flex>
      <v-flex xs12 md9 style="text-align: center">
            <span style="font-size: 24pt; font-weight: bold">{{siteSubname}}</span>
        <div style="text-align: center"><span class="taps-free-estimate-text">Free Estimates</span></div>
        <span><a style="font-size: 24pt; color: black; font-weight: bold; text-decoration: none" :href="phoneLink">{{phoneValue}}</a></span>
      </v-flex>
      <RedLine />
      <v-flex xs12 class="hidden-md-and-up">
        <span style="font-size: 16pt; color: dimgray; text-align: left">{{street}}<br />{{city}}, {{state}} {{zip}}</span>
      </v-flex>
      <v-flex xs12 class="hidden-sm-and-down">
        <span style="font-size: 16pt; color: dimgray; text-align: left">{{street}}   {{city}}, {{state}} {{zip}}</span>
      </v-flex>
      <TapsSpacer />
      <Carousel />
      <TapsSpacer />
      <RedBlock>{{firstRedBlock}}</RedBlock>
      <Description />
      <TapsSpacer />
      <RedLine />

      <Services />

      <TapsSpacer />
      <RedBlock>{{secondRedBlock}}</RedBlock>

      <v-flex xs12>
        <GalleryComponent :images="smallGalleryImages" :show-more="showMore"/>
      </v-flex>

      <TapsSpacer />

      <RedLine />
      <Contact />
    </v-layout>
  </v-container>
    <div class="imgbox" v-if="dialog">
      <img :src="selectedImage" class="center-fit" @click="closeDialog()">
    </div>
    <div id="overlay" @click="closeDialog()"></div>
    <div :class="{'imgbox': dialog}" @click="closeDialog()">
      <img :src="selectedImage" class="center-fit" @click="closeDialog()"  />
    </div>
  </div>
</template>

<script>
  import Contact from './Contact'
  import Carousel from './Carousel'
  import RedBlock from './RedBlock'
  import TapsSpacer from './TapsSpacer'
  import Description from './Description'
  import RedLine from './RedLine'
  import Services from './Services'
  import GalleryComponent from './GalleryComponent'
  import { sync } from 'vuex-pathify';
  const axios = require('axios');

  export default {
    data () {
      return {
        showMore: true,
        dialog: false,
        thumbHeight: 250,
        selectedImage: ''
      }
    },
    components: {
      Services,
      Contact,
      Carousel,
      RedBlock,
      TapsSpacer,
      Description,
      RedLine,
      GalleryComponent
    },
    computed: {
      ...sync(['siteName', 'siteSubname', 'phoneLink', 'phoneValue','street', 'city', 'state',
        'zip', 'firstRedBlock', 'secondRedBlock', 'smallGalleryImages', 'serviceUrl',
        'serviceEndpoints.GET_GALLERY_SMALL', 'navbarLargeLogo', 'imageUrl']),
    },
    methods: {
      openDialog: function(image) {
        document.getElementById("overlay").style.display = "block";
        this.selectedImage = image;
        this.dialog = true;
      },
      closeDialog: function() {
        this.selectedImage = '';
        this.dialog = false;
        document.getElementById("overlay").style.display = "none";
      }
    },
    mounted: function () {
      let me = this;
      axios.get(this.serviceUrl + this.GET_GALLERY_SMALL)
              .then(function (response) {
                me.smallGalleryImages = response.data.payload;
              })
              .catch(function (error) {
                console.log(error);
              })
    }
  }
</script>

<style>
  .taps-free-estimate-text {
    color: red;
    font-family: Serif,serif;
    font-size: 24pt;
  }
  * {
    margin: 0;
    padding: 0;
  }
  .imgbox {
    position: fixed;
    top: 5%;
    left: 5%;
    width: 90%;
    height: 90%;
    z-index: 3; /* Specify a stack order in case you're using a different order for other elements */
  }
  .center-fit {
    max-height: 100%;
    max-width: 100%;
    margin: auto;
    display: block;
  }
  #overlay {
    position: fixed; /* Sit on top of the page content */
    display: none; /* Hidden by default */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5); /* Black background with opacity */
    z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer; /* Add a pointer on hover */
  }
  .taps-title {
    text-align: center;
    color: #DB1918;
    font-weight: bold;
    font-family: Serif;
    font-size: 58pt;
  }
</style>
